import numeral from "numeral";
import dayjs from "dayjs";

const format = (value, pattern) => {
    if (isNumber(value)) {
        return formatNumber(value, pattern);
    } else if (isDate(value)) {
        return formatDate(value, pattern);
    }
    return value;
}

const formatNumber = (value, pattern) => {
    pattern = pattern || "0.00";
    return numeral(value).format(pattern);
}

const formatDate = (value, pattern) => {
    pattern = pattern || "YYYY-MM-DD HH:mm:ss";
    if (!dayjs.isDayjs(value)) {
        value = dayjs(value);
    }
    return value.format(pattern);
}

const parse = value => {
    if (isNumberString(value)) {
        return parseNumber(value);
    } else if (isDateString(value)) {
        return parseDate(value, false);
    }
    return value;
}

const parseNumber = value => {
    return numeral(value).value();
}

const parseDate = (value, toDate) => {
    let day = dayjs(value);
    if (toDate === true) {
        return day.toDate();
    } else {
        return day;
    }
}

const isNumber = value => {
    return typeof value == "number";
}

const isDate = (value, onlyDayjs) => {
    return (onlyDayjs && value instanceof Date) || dayjs.isDayjs(value);
}

const isNumberString = value => {
    return typeof value == "string" && /^[0-9]+(\.[0-9]+)?$/.test(value);
}

const isDateString = value => {
    return typeof value == "string" && /^[0-9]{4}-[0-9]{2}-[0-9]{2}( [0-9]{2}:[0-9]{2}:[0-9]{2})?$/.test(value);
}

const AnyFormat = {
    format,
    formatNumber,
    formatDate,
    parse,
    parseNumber,
    parseDate,
    isNumber,
    isDate,
    isNumberString,
    isDateString,
    install(Vue) {
        Vue.mixin({
            filters: {
                format
            }
        });
    }
};

export default AnyFormat;